const setBuildingAndUnit_sec2 = (payload) => {
  return {
    type: "BuildingAndUnit_sec2",
    payload,
  };
};

export default setBuildingAndUnit_sec2;
